import { RM05_03 } from "./RM05_03";

export const RM05_02 = {
  selectedValueColumn: "RegionDistrictCode",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territories",
        binding: {
          data: {
            columns: [
              {
                name: "MR Name",
                columnName: "MRName",
                width: "250px",
                align: "left",
                sortable: true,
              },
              {
                name: "Area",
                columnName: "Area",
                width: "450px",
                align: "left",
                sortable: true,
              },
              {
                name: "Coverage",
                columnName: "Coverage",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target",
                columnName: "Target",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Coverage %",
                columnName: "CoveragePercent",
                width: "150px",
                align: "center",
                sortable: true,
                percent: true,
              },
              {
                name: "MR Team",
                columnName: "MRTeam",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Working Days",
                columnName: "WorkingDays",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Average Call",
                columnName: "AverageCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target Average Call",
                columnName: "TargetAverageCall",
                width: "200px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Team Call",
                columnName: "ActualTeamCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target Team Call",
                columnName: "TargetTeamCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Call Rate",
                columnName: "CallRate",
                width: "170px",
                align: "center",
                sortable: true,
                percent: true,
              },
            ],
            title: "Area",
            endpoint: "RM05.2",
            parameters: [
              { key: "FromMonth", value: "CP1" },
              { key: "FromYear", value: "2026" },
              { key: "ToMonth", value: "CP1" },
              { key: "ToYear", value: "2026" },
              { key: "RegionDistrictCode", value: "" },
              { key: "RegionCode", value: "" },
            ],
          },
          context: {
            point: {
              onClick: RM05_03,
            },
          },
        },
      },
    },
  ],
};
